import { render, staticRenderFns } from "./addnew.vue?vue&type=template&id=779add0c&scoped=true"
import script from "./addnew.vue?vue&type=script&lang=js"
export * from "./addnew.vue?vue&type=script&lang=js"
import style0 from "./addnew.vue?vue&type=style&index=0&id=779add0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779add0c",
  null
  
)

export default component.exports